import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import logo from '../../images/logo.png';

const API_ENDPOINT = 'https://system.sales-management.cloud/api/auth.php';
const LINE_LOGIN_URL = 'https://system.sales-management.cloud/line/login';

export default function LoginForm() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError(''); // エラーメッセージをクリア
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(API_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: formData.username,
          password: formData.password
        })
      });

      const data = await response.json();

      if (data.status === 'success') {
        // トークンをCookieに保存（7日間有効）
        Cookies.set('auth_token', data.data.token, { expires: 7 });
        
        // ユーザー情報をCookieに保存（ロール情報を含む）
        const userInfo = {
          id: data.data.user.id,
          name: data.data.user.name,
          username: data.data.user.username,
          role: data.data.user.role
        };
        
        Cookies.set('user_info', JSON.stringify(userInfo), { expires: 7 });
        
        // localStorageにイベントを発火してSidebarに通知
        localStorage.setItem('user_info_updated', Date.now().toString());
        localStorage.removeItem('user_info_updated');

        // トークン情報をCookieに保存
        if (data.data.token_info) {
          Cookies.set('token_info', JSON.stringify(data.data.token_info), { expires: 7 });
        }

        // ログイン成功後、ホームページへリダイレクト
        navigate('/');
      } else {
        // エラーメッセージを表示
        setError(data.message || 'ログインに失敗しました');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('通信エラーが発生しました。もう一度お試しください。');
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <img
            alt="Your Company"
            src={logo}
            className="mx-auto h-20 w-auto"
            style={{mixBlendMode: 'multiply'}}
          />
          <h2 className="mt-5 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
            ログイン
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
              <p className="text-sm text-red-600">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900">
                アカウントID
              </label>
              <div className="mt-2">
                <input
                  id="username"
                  name="username"
                  type="text"
                  required
                  autoComplete="username"
                  value={formData.username}
                  onChange={handleChange}
                  disabled={loading}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border shadow placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">
                  パスワード
                </label>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  autoComplete="current-password"
                  value={formData.password}
                  onChange={handleChange}
                  disabled={loading}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 border shadow placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:bg-indigo-400 disabled:cursor-not-allowed"
              >
                {loading ? 'ログイン中...' : 'ログイン'}
              </button>
            </div>

            <div>
              <a
                href={LINE_LOGIN_URL}
                className="flex w-full justify-center rounded-md bg-green-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-green-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
              >
                LINEでログイン
              </a>
            </div>
          </form>

          <p className="mt-10 text-center text-sm/6 text-gray-500">
            アカウントがない場合、管理者に発行依頼をしてください。
          </p>
        </div>
      </div>
  )
}
